module.exports = __webpack_public_path__ + "assets/pricing-Illustration.236c174b.svg";